<script lang="ts" module>
	import { onDestroy } from "svelte";
	import { SvelteMap, SvelteSet } from "svelte/reactivity";
	import type { IconProps } from "./Icon.js";
	import type { IconVariables } from "./IconVariables.js";

	const instances = new SvelteMap<string, SvelteSet<string>>();
</script>

<script lang="ts">
	const { vars, forceRender = false, ...props }: IconProps & { vars: IconVariables } = $props();
	const { iconId, raw, attributes } = $derived(vars);

	const instanceId = $props.id();
	const id = $derived(forceRender ? instanceId : iconId);

	$effect(() => {
		if (!instances.has(iconId)) {
			instances.set(iconId, new SvelteSet([instanceId]));
		} else {
			instances.get(iconId)?.add(instanceId);
		}
	});

	onDestroy(() => {
		instances.get(iconId)?.delete(instanceId);
		if (instances.get(iconId)?.size === 0) {
			instances.delete(iconId);
		}
	});

	const source = $derived(instances.get(iconId)?.values().next().value);
	const isSource = $derived(source === instanceId);

	/* eslint-disable svelte/no-at-html-tags */
</script>

<svg
	{...props}
	focusable="false"
	aria-hidden={Boolean(props["aria-label"] ?? props["aria-labelledby"] ?? props.title) || props.role === "img"
		? undefined
		: "true"}
>
	{#if isSource || forceRender}
		<symbol {...attributes} {id}>
			{@html raw}
		</symbol>
	{/if}
	<use href="#{id}"></use>
</svg>
